import { render, staticRenderFns } from "./form_add_happiness_tips_categories_component.vue?vue&type=template&id=ff34db38&scoped=true"
import script from "./form_add_happiness_tips_categories_component.vue?vue&type=script&lang=js"
export * from "./form_add_happiness_tips_categories_component.vue?vue&type=script&lang=js"
import style0 from "./form_add_happiness_tips_categories_component.vue?vue&type=style&index=0&id=ff34db38&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff34db38",
  null
  
)

export default component.exports